import React from "react";

import { useLocation } from "@reach/router";

import { UrlParamKeyEnum } from "@/components/constants";
import { FormTypeEnum } from "@/components/layout/modals/types";
import { setAuthParamToURL } from "@/components/layout/modals/utils";
import GlobalContext from "@/contexts/Global/GlobalContext";
import UserContext from "@/contexts/User/UserContext";
import { isBrowser } from "@/utils/env";
import { isPageWithoutMobileBottomMenu } from "@/utils/urlUtils";

export const useOnboardingForClient = () => {
  const { pathname } = useLocation();
  const { isUserLoggedIn, shouldShowWbOffer, wbOfferPrice } = React.useContext(UserContext);
  const { isExpert } = React.useContext(GlobalContext);

  const isSubdomainLanding = (!!process.env.GATSBY_SUBDOMAIN
    && (pathname === "/" || (!isBrowser() && pathname === "")));
  const isExcludedPage = isPageWithoutMobileBottomMenu(pathname) || isSubdomainLanding;

  const isLoggedInClientWithZeroPriceWbOffer = shouldShowWbOffer && wbOfferPrice === 0;

  const isActiveOnboarding = !isExcludedPage
    && !isExpert
    && (!isUserLoggedIn || isLoggedInClientWithZeroPriceWbOffer);

  const openOnboardingModal = () => {
    if (isBrowser()) {
      setAuthParamToURL(window.location, FormTypeEnum.Onboarding);
    }
  };
  const linkForOpenOnboarding = `/?${UrlParamKeyEnum.LoginFormModal}=${FormTypeEnum.Onboarding}`;

  return { isActiveOnboarding, openOnboardingModal, linkForOpenOnboarding };
};

export default useOnboardingForClient;
